import {
    FETCH_LOTTO99,
    LIST_LOTTO99
} from "./types";

const init = {
    isLoading: false,
    list: [],
    page: 1,
    size: 10,
    totals: 0
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_LOTTO99:
            return {
                ...state,
                ...init,
                isLoading: true
            };
        case LIST_LOTTO99:
            return {
                ...state,
                isLoading: false,
                list: payload.data,
                ...payload.paging
            };
        default:
            return state;
    }
}